import { InMemoryCache, defaultDataIdFromObject } from '@apollo/client'
import get from 'lodash/get'
import possibleTypes from './possibleTypes.json'

const dataIdFromObject = (object) => {
  switch (object.__typename) {
    case 'CustomerTarget':
      return [object.productType, object.date, object.station.id].join(':')
    case 'CalculatedBuffetTarget':
      return [object.date, object.startTime, object.endTime, object.station.id].join(':')
    case 'CookingPlan':
      return [object.date, object.station.id].join(':')
    case 'VitrineProductWithWeight':
      return [object.id, object.stationId, object.timeslot].join(':')
    case 'BudgetPlan':
      return object.id || [object.date, object.station.id, get(object, 'profitCenter.id')].join(':')
    case 'ShiftManager':
      return [object.id, object.shift].join(':')
    case 'VitrineProductTimeslotWeight':
      return [object.productType, object.timeslot, object.weekday].join(':')
    case 'WastageBoundary':
      return [object.productType, object.id, object.lowerWastageBounds, object.upperWastageBounds].join(':')
    case 'ScheduleCategory':
      return [object.id, object.opens, object.closes].join(':')
    case 'DefaultOpeningHoursPeriod':
      return [
        object.periodId,
        object.categoryId,
        object.startDate,
        object.endDate,
        JSON.stringify(object.openingHours),
      ].join(':')
    case 'CategoryProduct':
      return [object.id, object.targets?.map((target) => target.n).join(',') ?? ''].join(':')
    default:
      return defaultDataIdFromObject(object)
  }
}

const cache = new InMemoryCache({
  possibleTypes,
  dataIdFromObject,
})

export default cache
